import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityStateUpdater from 'component/EntityStateUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormErrors from 'components/forms/FormErrors';

import Loader from 'components/layout/Loader';

import Entity from 'components/Entity';
import Data from 'components/Data';
import Modal from 'components/Modal';

import { entityMetaMapping } from 'js/constants';

class LeadFilledQuestionnaireNew extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entity: null,
      entityLoaded: false,
    };

    const { lead } = props;
    const sendAsMessage =
      !!(lead && lead.target && lead.target.profile && lead.target.profile.email) ||
      !!(
        lead.getTarget &&
        lead
          .getTarget()
          .getProfile()
          .getEmail()
      );

    this.entity = new Entity();
    this.entity.setData({
      token: '-',
      bccCreator: sendAsMessage,
      lead,
      sendAsMessage,
    });

    if (
      props.meta[entityMetaMapping.filledQuestionnaire] !== undefined &&
      !props.meta[entityMetaMapping.filledQuestionnaire].pending
    ) {
      this.entity.setMeta(props.meta, entityMetaMapping.filledQuestionnaire);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }

    this.bccSwitcherRef = React.createRef();
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.filledQuestionnaire] !== undefined &&
      !meta[entityMetaMapping.filledQuestionnaire].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.filledQuestionnaire);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          const { lead } = this.props;
          const clientId = lead.target && lead.target.id ? lead.target.id : lead.getTarget().getUsername();
          if (this.state.entity.isValid) {
            this.props.onSubmit({
              ...this.state.entity.processedData,
              target: { username: clientId },
              lead: { id: lead.id || lead.getId() },
              contexts: this.props.formContext ? [this.props.formContext] : [],
            });
          }
        }
      );
    }, 150);

    return false;
  };

  updateQuestionnaire = (name, value) => {
    this.updateEntityMultiple([name, 'name'], [value, value.name]);
  };

  updateSendAsMessage = (name, value) => {
    const { user } = this.props;

    this.updateEntity(name, value, [], () => {
      if (user.profile.email && this.bccSwitcherRef.current) {
        this.updateEntity('bccCreator', value, [], () => {
          this.bccSwitcherRef.current.setValue(value);
        });
      }
    });
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      formStatus,
      user,
      lead,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    const disabled = formStatus.pending;
    const sendAsMessageDisabled =
      !lead ||
      (lead.getTarget &&
        !lead
          .getTarget()
          .getProfile()
          .getEmail()) ||
      (!lead.getTarget && (!lead.target || !lead.target.profile || !lead.target.profile.email));

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.request_filling_out_questionnaire}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="filledQuestionnaire" />
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form type="post" onSubmit={this.onSubmit}>
              <Row className="m-b-20">
                <Col xs={12}>
                  <div className="form-group-attached">
                    <FormAutocomplete
                      label={messages.questionnaire}
                      autocompleteType="questionnaire"
                      name="questionnaire"
                      onChange={this.updateQuestionnaire}
                      disabled={disabled}
                      returnValueObject
                    />
                  </div>

                  <div className="m-t-15">
                    <div className="m-b-10">
                      <FormSwitchery
                        name="sendAsMessage"
                        label={messages.send_questionnaire_as_message}
                        value
                        checked={!sendAsMessageDisabled && entity.getSendAsMessage()}
                        onChange={this.updateSendAsMessage}
                        disabled={sendAsMessageDisabled || formStatus.pending}
                      />
                    </div>
                    {!!user.profile.email && (
                      <div className="m-b-10">
                        <FormSwitchery
                          ref={this.bccSwitcherRef}
                          name="bccCreator"
                          label={messages.send_copy_to_me + ' (' + user.profile.email + ')'}
                          value
                          checked={!sendAsMessageDisabled && entity.getSendAsMessage() && entity.getBccCreator()}
                          onChange={this.updateEntity}
                          disabled={sendAsMessageDisabled || formStatus.pending}
                        />
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              <Button bsStyle="primary" bsSize="lg" block disabled={disabled} type="submit">
                {formStatus.pending ? <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                {messages.save}
              </Button>
            </form>
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
    formContext: state.formStatus.context,
    formStatus: state.formStatus.filledQuestionnaireNew,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: args => {
      formStatusDispatchHelper('filledQuestionnaireNew', `/api/filledquestionnaires.json`, args, 'post', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadFilledQuestionnaireNew)
  )
);
